function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("ellipse", {
  cx: 28.774,
  cy: 30.268,
  fill: "#FBBFBA",
  fillOpacity: 0.35,
  rx: 28.774,
  ry: 29.402
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M44.648 21.335H31.46c-.966.085-1.68.857-1.68 1.8V59.97c.084.986.84 1.715 1.764 1.715h13.062c.966 0 1.764-.815 1.764-1.801V23.05c-.042-.986-.798-1.715-1.722-1.715zm-.546 38.033H32.09v-1.586h2.73c.63 0 1.176-.515 1.176-1.2 0-.687-.504-1.201-1.176-1.201h-2.73v-3.56h5.124c.63 0 1.176-.514 1.176-1.2 0-.686-.504-1.2-1.176-1.2H32.09v-3.645h2.772c.63 0 1.134-.515 1.134-1.158 0-.643-.504-1.2-1.134-1.2H32.09V39.9h5.124c.63 0 1.176-.514 1.176-1.2 0-.686-.504-1.2-1.176-1.2H32.09v-3.603h2.772c.63 0 1.134-.557 1.134-1.2 0-.644-.546-1.158-1.176-1.158h-2.772v-3.56l5.124-.042c.63 0 1.134-.557 1.134-1.2 0-.644-.504-1.158-1.134-1.158l-5.082.043v-1.93h12.012v35.675zM63.716 22.02a1.665 1.665 0 00-1.218-.514 146.008 146.008 0 00-7.518-.086c-.504 0-.966.172-1.302.472-.336.343-.546.772-.546 1.286l-.042 28.815v.257l4.41 9.09c.168.387.504.644.924.687h.21c.336 0 .672-.129.924-.43l.126-.128 4.494-9.219.042-28.986c0-.471-.21-.9-.504-1.243zm-1.806 1.802v4.673h-6.468V23.78c2.142-.043 4.326 0 6.468.043zm-3.276 34.56l-2.562-5.188h.546c.63 0 1.134-.515 1.134-1.2 0-.687-.504-1.159-1.176-1.159h-1.26l.084-19.981h6.468v19.981h-1.26c-.63 0-1.134.515-1.134 1.2 0 .687.504 1.159 1.176 1.159h.546l-2.562 5.188z"
});

function SvgDesigninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 68 64"
  }, props), _ref, _ref2);
}

export default SvgDesigninline;